export function createActionLock() {
  let locked = false;
  return {
    get locked() {
      return locked;
    },
    async run<T>(task: () => Promise<T>): Promise<T | undefined> {
      if (locked) return undefined;
      locked = true;
      try {
        return await task();
      } finally {
        locked = false;
      }
    },
  };
}
